export const fetchTemplates = async () => {
  // mock templates
  return [
    {
      id: '1',
      name: 'Test template',
      category: 'salsa_1',
      isActive: true,
    },
    {
      id: '2',
      name: 'Test template 2',
      category: 'salsa_1',
      isActive: true,
    },
  ];
};

export const publishTemplate = async (templateId: string) => {
  // TODO: Implement publish functionality
  console.log('Publishing template', templateId);
};
